





























/* tslint:disable */
import Vue from 'vue'
import 'popper.js'
import 'bootstrap'
import 'bootstrap-select'
import 'vue-select/dist/vue-select.css'
import libphonenumber from 'google-libphonenumber'
import Postmate from 'postmate'
// import "bootstrap-daterangepicker";
import { Company, User, getCountryInfo } from '../models'
import moment from 'moment-timezone'
import { mapState } from 'vuex'
import { CompanyState, UserState, IframeState } from '../store/state_models'
import postscribe from 'postscribe'
import currencyList from '../util/currency'
import * as Ux from '@/util/ux_message'
import handlebars from 'handlebars'
import ImagePreviewModal from './components/ImagePreviewModal.vue'
import UxMessageModal from './components/util/UxMessageModal.vue'
import UxToaster from './components/util/UxToaster.vue'

import OnboardingModal from './components/util/OnboardingModal.vue'
import ManualCallStatusModal from './components/ManualCallStatusModal.vue'
import OverusedWarning from '@/pmd/components/agency/billing/OverusedWarning.vue'
import RetryInvoiceWarning from '@/pmd/components/agency/billing/RetryInvoiceWarning.vue'
import GMBMessagingWarning from '@/pmd/components/GMBMessagingWarning.vue'
import GMBConnectionWarning from '@/pmd/components/GMBConnectionWarning.vue'
import WarningManager from '@/pmd/components/common/WarningManager.vue'
import TermsOfService from '@/pmd/components/launchpad/TermsOfService.vue'
import Overlay from '@/pmd/components/sidebar/Overlay.vue'
import EditAppointmentModalV2 from '@/pmd/components/EditAppointmentModalV2.vue'
import EmailTemplateBuilderModal from '@/pmd/pages/emailBuilder/EmailTemplateBuilderModal'
import ContentAIModals from '@/pmd/pages/content_ai/ContentAIModals.vue'
import DomainConnectModals from '@/pmd/pages/domain_connect/DomainConnectModals.vue'
import NewMessageModalV2 from '@/pmd/pages/conversations/NewMessageModalV2.vue'

import config from '@/config'
import { AgencyproPlusAddonPlan } from '@/models/company'
import * as Sentry from "@sentry/vue";
import AppLoader from './loader/AppLoader.vue'


const numeral = require('numeral')
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
let timeout: NodeJS.Timer

var userData = {} as any
var companyData = {} as any
initFreshDesk()

function initFreshChat() {
  window.fcWidget.init({
    token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
    host: 'https://highlevel-team.freshchat.com',
    siteId: userData.id,
    // tags: ["prioritysupport"],//tags your defined in topic settings
    config: {
      headerProperty: {
        hideChatButton: true,
      },
      content: {
        headers: {
          csat_question: 'Are you satisfied with the support provided?',
        },
      },
    },
  })
  window.fcWidget.setExternalId(userData.id)
  window.fcWidget.user.setFirstName(userData.name)
  window.fcWidget.user.setEmail(userData.email)
  window.fcWidget.user.setProperties({
    firstName: userData.name, //user's first name
    //    lastName: userData., //user's last name
    email: userData.email, //user's email address
    phone: userData.phone, //phone number without country code
    'Company_Id': companyData.id,
    'Company_Name': companyData.name,
    'Company_Email': companyData.email,
    'Company_Creation_Date': companyData.created,
    'status': companyData.status,
    'Company_Plan': companyData.activePlan,
    'Company_Stripe_ID': companyData.stripeId,
    'Relationship_ID':companyData.relationshipNumber,
    'priority': companyData.prioritySupport ? 3 : 1,
    'datePurchase': companyData.datePurchase,
    'daySincePurchase': companyData.daySincePurchase,
    'first_implementation_call_date': companyData.firstImplementationCallDate,
    'implementation_csr_1': companyData.implementationCSR1
  })
  window.fcWidget.on("message:received", (res) => {
   if(!window.fcWidget.isOpen()){
     if(companyData.prioritySupport) {
      window.fcWidget.setTags(['prioritysupport'])
     }else {
       window.fcWidget.setTags([])
     }
     window.fcWidget.open()
   }
  })
}

function initializeFreshchat(i: any, t: any) {
  var e
  i.getElementById(t)
    ? initFreshChat()
    : (((e = i.createElement('script')).id = t),
      (e.async = !0),
      (e.src = 'https://highlevel-team.freshchat.com/js/widget.js'),
      (e.onload = initFreshChat),
      i.head.appendChild(e))
}

function setupFreshDesk() {
  window.fwSettings = {
    widget_id: 48000001416,
  }
  !(function() {
    if ('function' != typeof window.FreshworksWidget) {
      var n = function() {
        n.q.push(arguments)
      }
      ;(n.q = []), (window.FreshworksWidget = n)
    }
  })()
}

function initFreshDesk() {
  if (window.FreshworksWidget) {
    window.FreshworksWidget('hide', 'launcher')
    window.FreshworksWidget('identify', 'ticketForm', {
      name: userData.name,
      email: userData.email,
    })
    window.FreshworksWidget('prefill', 'ticketForm', {
      priority: 2,
      custom_fields: {
        cf_highlevel_login_email: userData.email,
      },
    })
    window.FreshworksWidget('hide', 'ticketForm', ['priority'])
  }
}

function initializeFreshdesk(i: any, t: any) {
  var e
  i.getElementById(t)
    ? initFreshDesk()
    : (setupFreshDesk(),
      ((e = i.createElement('script')).id = t),
      (e.async = !0),
      (e.src = 'https://widget.freshworks.com/widgets/48000001416.js'),
      (e.onload = initFreshDesk),
      i.head.appendChild(e))
}

function initiateCall() {
  initializeFreshchat(document, 'freshchat-js-sdk')
  initializeFreshdesk(document, 'freshdesk-js-sdk')
  // initializeFreshBot(document,"spd-busns-spt")
}

function initializeFreshBot(d: any, scriptId:any,){
  if(d.getElementById("spd-busns-spt")){
    // Run freshbot widget
      initFreshbotWidget()
  }else{
    var
    n = d.getElementsByTagName('script')[0],
    s = d.createElement('script');
    s.id = scriptId;
    s.async = "async";
    s.setAttribute("data-self-init", "false");
    s.setAttribute("data-init-type", "opt");
    s.src = 'https://cdn.freshbots.ai/assets/share/js/freshbots.min.js';
    s.setAttribute("data-client", "ad77d455c17da341af4880798cc4b4bc8417eeaa");
    s.setAttribute("data-bot-hash", "e28ea11aa90be898beaa87981fe097f312e4d002");
    s.setAttribute("data-env", "prod");
    s.setAttribute("data-region", "us");
    s.onreadystatechange = s.onload = initFreshbotWidget
    d.head.appendChild(s)
    // n.parentNode.insertBefore(s, n);
  }
}

function initFreshbotWidget(){
    window.Freshbots.initiateWidget(
      {
        autoInitChat: false,
        getClientParams: function () {
            //let priority = 2;
            let priority = 1;
            /*
            Old Code Reference:
            if(companyData.activePlan) {
              switch (companyData.activePlan.split('_')[2]) {
                case '97':
                  priority = 1
                  break
                case '297':
                case '237':
                  priority = 2
                  break
                case '497':
                  priority = 3
                  break
                default:
                  priority = 2
              }
            }
            if(companyData.status && companyData.status.includes('active_trial')) {
              priority = 3;
            }
            if(companyData.prioritySupport) {
              priority = 4;
            }
             */
            if(companyData.prioritySupport) {
              priority = 3;
            }
          return {
            "cstmr::eml": userData.email,
            "cstmr::xtrInfrmtn:Relationship_ID": companyData.relationshipNumber,
            "cstmr::xtrInfrmtn:Priority": priority,
            "cstmr::xtrInfrmtn:agency_active_plan": companyData.activePlan,
            "cstmr::phn": userData.phone,
            "cstmr::nm":userData.name
          }
        }
      },
      function (successResponse) {
        // Hide Launcher
        //window.Freshbots.hideWidget()
        let isMoreThanOneChatbotDOMEleExist = document.querySelectorAll('#fbots-wdgt')
        // If we have more than one chatbotWidget DOM Element, it cause UI issue. EG:User not able to Type in chatbot. So removing duplicate ChatBot DOM Element.
        // Case: Happen In Location Calender Page.
        if(isMoreThanOneChatbotDOMEleExist.length > 1){
          do {
          // code block to be executed
            isMoreThanOneChatbotDOMEleExist[1].remove()
          }
          while (isMoreThanOneChatbotDOMEleExist.length == 1)
        }

        // Case: Happens after users returns from emailbuilder etc.
        let fbotsWdgt = document.getElementById('fbots-wdgt')
        const mutationObserver = new MutationObserver(entries => {
          if(entries[0].attributeName == "style"){
            // If style become inline,It will collapse the widget, so bring back to its original style.
            if(fbotsWdgt?.style.display === 'inline'){
              fbotsWdgt.style.display = 'none'
            }
          }
        })
        // Listening to attribute changes in DOM.
        mutationObserver.observe(fbotsWdgt, { attributes:true })
      },
      function (errorResponse) {
      }
    );
}

export default Vue.extend({
  metaInfo() {
    return {
      title: this.company?.name
    }
  },
  components: {
    ImagePreviewModal,
    UxMessageModal,
    OnboardingModal,
    UxToaster,
    ManualCallStatusModal,
    OverusedWarning,
    RetryInvoiceWarning,
    GMBMessagingWarning,
    GMBConnectionWarning,
    WarningManager,
    TermsOfService,
    Overlay,
    EditAppointmentModalV2,
    EmailTemplateBuilderModal,
    ContentAIModals,
    NewMessageModalV2,
    AppLoader,
    DomainConnectModals
},
  data() {
    return {
      authUser: {} as any,
      currentLocationId: '',
      sideBarStateValue: false,
      disableWM: false,
    }
  },
  async created() {
    this.$store.dispatch('init')
    this.authUser = await this.$store.dispatch('auth/get')
    if ( (this.$route.name === 'login_page' || this.$route.name === 'login') && window.pendo) {
      window.pendo.clearSession()
    }
    window.addEventListener('beforeunload', (event) => {
      localStorage.setItem('lastRefresh', new Date().toISOString())
    })
  },
  computed: {
    loaderIsActive() {
      return this.$store.state.locationLoaderActive || this.$store.state.agencyLoaderActive
    },
    isUserSwitching() {
      return this.$store.getters['auth/isUserSwitching'];
    },
    ...mapState('company', {
      company: (s: CompanyState) => {
        return s.company ? new Company(s.company) : undefined
      },
    }),
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(s.user) : undefined
      },
    }),
    ...mapState('locations', ['locations']),
    sideBarState() {
      return this.$store.getters.getManualCollapseSidebar
    },
    ...mapState('iframe', {
      iframe: (s: IframeState) => {
        return s.iframe ? new Iframe(s.iframe) : undefined
      },
    }),
    isV2SideBarEnabled() {
      return this.$store.getters['sidebarv2/getVersion'] == 'v2'
    },
    classes() {
      let classes = ''
      classes += this.sideBarState && this.$route.params.location_id
          ? `pmd-app ${this.$route.params.location_id}`
          : `${this.$route.params.location_id}`
      classes += this.isV2SideBarEnabled ? ' flex' : ''
      classes += this.sideBarState ? ' v2-collapse' : ' v2-open'
      classes += ` ${this.v2Id}`
      return classes
    },
    v2Id() {
      if (!this.$route.params.location_id) {
        return this.isV2SideBarEnabled ? 'sidebar-v2-agency' : ''
      } else {
        return this.isV2SideBarEnabled && this.isV2SideBarRoute && !this.isOnbording ? 'sidebar-v2-location' : ''
      }
    },
    isV2SideBarRoute() {
      return this.$route.path.includes('/v2/location')
    },
    v2SideBarStyles() {
      if (!this.$route.params.location_id) {
        return this.isV2SideBarEnabled ? 'padding-top: 0px !important; overflow: hidden; height: 100vh; width: 100%;' : ''
      } else {
        return this.isV2SideBarEnabled && this.isV2SideBarRoute ? 'padding-top: 0px !important; overflow: hidden; height: 100vh;' : ''
      }
    },
    isOnbording() {
      return this.$router.currentRoute.query.onboarding && this.$router.currentRoute.query.onboarding == 'true'
    },
    isInternalUser() {
      return this.$store.state.user.internalUser
    },
    userAndCompany() {
      return !!this.user && !!this.company
    },
    showTermsOfService() {
      return this.company && this.user && !this.isInternalUser && this.company.termsOfServiceVersion && 
      this.company.termsOfServiceVersion !== config.tosVersion
    }
  },
  provide: function() {
    return {
      uxmessage: this.uxmessage,
    }
  },
  watch: {
    '$route.params.location_id': function(id) {
      Sentry.setUser({ userId: this.user.id , companyId: this.user.companyId, locationId: id });
      this.initPendo();
      if (this.$route.params.location_id) {
        this.currentLocationId = id
        this.disableWM = true
      } else {
        this.disableWM = false
      }
    },
    user: function(newUser, oldUser) {
      this.initPendo();
      if (!oldUser && newUser) {
        if (
          newUser.type === 'agency'
        ) {
          this.identifyCanny();
        }
        Sentry.setUser({ userId: this.user.id , companyId: this.user.companyId });
      }
      if (!newUser && oldUser) {
        Sentry.setUser(null);
      }
    },
    company: function(newCompany, oldCompany) {
      this.initPendo();
      this.identifyCanny();
      if (!oldCompany && newCompany) {
        if (newCompany.logoURL) {
          $('link[rel="icon"]').attr('href', newCompany.logoURL)
        }
        if (newCompany.name) {
          $('head').append(`<title>${newCompany.name}</title>`)
        }
        var jsParams = { user: this.user }
        if (newCompany && newCompany.customJavascript) {
          postscribe(
            '#customJS',
            handlebars.compile(newCompany.customJavascript)(jsParams, {
              allowProtoPropertiesByDefault: true,
            }),
            {
              done: function() {
                const customJavascript = newCompany.customJavascript
                if (
                  customJavascript.includes('birdseed') ||
                  customJavascript.includes('helpwise')
                ) {
                  const evt = document.createEvent('Event')
                  evt.initEvent('load', false, false)
                  window.dispatchEvent(evt)
                }
              },
            }
          )
          // } else {
          //   if (
          //     ['app.gohighlevel.com', 'localhost:8080'].indexOf(location.host) !==
          //     -1
          //   ) {
          //     /*<![CDATA[*/
          //     window.groove = window.groove || {}
          //     groove.widget = function() {
          //       groove._widgetQueue.push(Array.prototype.slice.call(arguments))
          //     }
          //     groove._widgetQueue = []
          //     groove.widget('setWidgetId', '44231df8-7404-ffad-6a81-3f534fd3b329')
          //     !(function(g, r, v) {
          //       var a,
          //         n,
          //         c = r.createElement('iframe')
          //       ;((c.frameElement || c).style.cssText =
          //         'width: 0; height: 0; border: 0'),
          //         (c.title = ''),
          //         (c.role = 'presentation'),
          //         (c.src = 'javascript:false'),
          //         r.body.appendChild(c)
          //       try {
          //         a = c.contentWindow.document
          //       } catch (i) {
          //         n = r.domain
          //         var b = [
          //           "javascript:document.write('<he",
          //           'ad><scri',
          //           'pt>document.domain=',
          //           '"',
          //           n,
          //           '";</scri',
          //           'pt></he',
          //           'ad><bo',
          //           'dy></bo',
          //           "dy>')"
          //         ]
          //         ;(c.src = b.join('')), (a = c.contentWindow.document)
          //       }
          //       var d = 'https:' == r.location.protocol ? 'https://' : 'http://',
          //         s = 'http://groove-widget-production.s3.amazonaws.com'.replace(
          //           'http://',
          //           d
          //         )
          //       ;(c.className = 'grv-widget-tag'),
          //         (a.open()._l = function() {
          //           n && (this.domain = n)
          //           var t = this.createElement('script')
          //           ;(t.type = 'text/javascript'),
          //             (t.charset = 'utf-8'),
          //             (t.async = !0),
          //             (t.src = s + '/loader.js'),
          //             this.body.appendChild(t)
          //         })
          //       var p = ['<bo', 'dy onload="document._l();">']
          //       a.write(p.join('')), a.close()
          //     })(window, document)
          //     /*]]>*/
          //   }
        }

        if (newCompany && newCompany.customCSS) {
          let customCSS = document.createElement('style')
          customCSS.type = 'text/css'
          customCSS.media = 'screen'
          customCSS.appendChild(document.createTextNode(newCompany.customCSS))
          document.head.appendChild(customCSS)
        }

        if (newCompany && newCompany.theme) {
          document.body.dataset.theme = newCompany.theme
        } else if (this.isV2SideBarEnabled && !newCompany.theme) {
          document.body.dataset.theme = 'default-dark-v1'
        }
      }
    },
    userAndCompany: function(newValue) {
      if (newValue && this.user.type === 'agency') {
        let datePurchase = this.company.billingInfo?.first_payment_date ? moment(this.company.billingInfo?.first_payment_date?.seconds * 1000).format('MMM DD, YYYY HH:mm') : ''
        let daySincePurchase = this.company.billingInfo?.first_payment_date ? moment().diff(this.company.billingInfo?.first_payment_date?.seconds * 1000, 'days') : ''
        let firstImplementationCallDate = this.company.onboardingInfo.meta_data?.first_implementation_call_date ? moment(this.company.onboardingInfo.meta_data?.first_implementation_call_date?.seconds * 1000).format('MMM DD,YYYY') : '' || ""
        let implementationCSR1 = this.company.onboardingInfo.meta_data?.implementation_csr_1 || ""
        companyData = {
          id: this.company.id,
          name: this.company.name || '',
          email: this.company.email || '',
          status: this.company.status || '',
          activePlan: this.company.stripeActivePlan || '',
          created: moment(this.company.dateAdded).format('MMM DD, YYYY'),
          relationshipNumber: this.company.relationshipNumber,
          prioritySupport: this.company.premiumUpgraded || (this.company.jumpstartSupported && this.company.jumpstartSupported.seconds * 1000 >= +new Date()) || false,
          datePurchase: datePurchase,
          daySincePurchase: daySincePurchase,
          firstImplementationCallDate: firstImplementationCallDate,
          implementationCSR1: implementationCSR1,
          stripeId: this.company.stripeId
        }
        userData.id = this.user.id
        userData.name = this.user.name
        userData.email = this.user.email
        userData.phone = this.user.phone
        initiateCall()
      }
    }
  },
  methods: {
    uxmessage(item: Ux.UxMessage, toastIt: boolean = false) {
      if (toastIt) this.$refs['UxToast'].show(item)
      else this.$refs['UxMessageModal'].show(item)
    },
    refreshTimer() {
      var _self = this
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        _self.signout()
      }, 30 * 60 * 1000)
    },
    async signout() {
      try {
        await this.$store.dispatch('auth/signOutFromBackend')
        await this.$store.dispatch('logout')
        await this.$auth.signOut()
      } catch (err) {}
      this.$router.push({ name: 'login' })
    },
    async initPendo(init = false) {
      try {
        if (!this.user || !this.company) {
          // initializing with blank object.
          // window.pendo && window.pendo.initialize({});
          return;
        }
        let companyPreviousTools = {};
        if(this.company && this.company.onboardingInfo && this.company.onboardingInfo.tools) {
          for(let prevTool of this.company.onboardingInfo.tools) {
            companyPreviousTools[`prev_tool_${prevTool}`] = true;
          }
        }

        let conditionBasedParentAccProperties = {}
        if (this.company.onboardingInfo.meta_data?.first_implementation_call_date) {
          conditionBasedParentAccProperties['first_implementation_date'] = moment(this.company.onboardingInfo.meta_data?.first_implementation_call_date.seconds * 1000).toISOString()
        }
        if (this.company.onboardingInfo.meta_data?.implementation_csr_1) {
          conditionBasedParentAccProperties['implementation_csr_1'] = this.company.onboardingInfo.meta_data?.implementation_csr_1
        }
        if (this.company.onboardingInfo.meta_data?.first_capture_call_date) {
          conditionBasedParentAccProperties['first_capture_date'] = moment(this.company.onboardingInfo.meta_data?.first_capture_call_date.seconds * 1000).toISOString()
        }
        if (this.company.onboardingInfo.meta_data?.capture_csr) {
          conditionBasedParentAccProperties[`capture_csr`] = this.company.onboardingInfo.meta_data?.capture_csr
        }
        if(this.company.billingInfo?.first_payment_date){
          conditionBasedParentAccProperties['date_purchase'] = moment(this.company.billingInfo?.first_payment_date?.seconds * 1000).toISOString()
        }

        if(this.company.locationCount || this.company.locationCount === 0){
          conditionBasedParentAccProperties['location_count'] = this.company.locationCount
        }

        let pro_plus_status: null | String = null
        if(this.company && this.company.billingInfo && this.company.billingInfo.agency_pro_addon && this.company.billingInfo.agency_pro_addon.is_active){
          let planLabel = this.company.billingInfo.agency_pro_addon.agency_pro_addon_active_plan
          pro_plus_status = planLabel === AgencyproPlusAddonPlan.Monthly ? 'pro_plus_addon_monthly_399' : 'pro_plus_addon_annual_399'
        }
        // console.log(this.user.dateAdded);
        let locationId = this.$route.params.location_id || '';
        let initObject = {
          visitor: {
            id: this.user?.id,                        // Required if user is logged in
            email: this.user?.email || '',            // Recommended if using Pendo Feedback, or NPS Email
            full_name: this.user?.fullName || '',     // Recommended if using Pendo Feedback
            role: this.user?.role,                    // Optional
            type: this.user?.type,
            date_created: (this.user?._data.date_added?.seconds) ? moment(this.user._data.date_added.seconds * 1000).toISOString() : '',
            company_id: this.user?.companyId || '',
            phone: this.user?.phone || '',
            // location_id:

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
          },
          parentAccount: {
            id: this.company.id,
            name: this.company.name,
            email: this.company.email,
            status: this.company.status || '',
            phone: this.company.phone || '',
            active_plan: this.company.stripeActivePlan || '',
            created: moment(this.company.dateAdded).toISOString(),
            is_hippa_enabled: this.company.hipaaStatus || false,
            is_priority_support_enabled: this.company.premiumUpgradeStatus || false,
            is_jumpstart_support_enabled: this.company.jumpstartSupported ? this.company.jumpstartSupported.seconds * 1000 >= +new Date() : false,
            is_whitelabel_app_enabled: this.company.whitelabelAppStatus || '',
            is_terms_of_service_accepted: this.company.termsOfServiceVersion == config.tosVersion,
            terms_of_service_accepted_by: this.company.termsOfServiceAcceptedBy,
            terms_of_service_accepted_date: this.company.termsOfServiceAcceptedDate ? moment(this.company.termsOfServiceAcceptedDate).toISOString() : "",
            experiance_nps_enabled: this.company.experianceNpsEnabled,
            experiance_guides_enabled: this.company.experianceGuidesEnabled,
            experiance_reports_enabled: this.company.experianceReportsEnabled,
            country: this.company.country || '',
            relationship_number: this.company.relationshipNumber || '',
            agency_stripe_customer_id: this.company.stripeId,
            agency_stripe_subscription_id: this.company.stripeSubscriptionId,
            is_ag_twilio_isv_enabled: this.company.inIsvMode,
            is_ag_twilio_pure_isv_enabled: this.company.inPureIsvMode,
            // OnboardingInfo
            customer_success_rep: this.company.onboardingInfo.meta_data?.customer_success_rep || "",
            first_onboarding_call_booked_on: this.company.onboardingInfo.meta_data?.first_onboarding_call_booked_on || "",
            first_onboarding_call_completed: this.company.onboardingInfo.meta_data?.first_onboarding_call_completed || "",
            second_onboarding_call_booked_on: this.company.onboardingInfo.meta_data?.second_onboarding_call_booked_on || "",
            second_onboarding_call_completed: this.company.onboardingInfo.meta_data?.second_onboarding_call_completed || "",

            //HL survey
            pa_usage_saass: this.company.hl_survey_values?.includes['saas'],
            pa_usage_client_business: this.company.hl_survey_values?.includes['client_business'],
            pa_usage_own_business: this.company.hl_survey_values?.includes['own_business'],
            pa_usage_all: this.company.hl_survey_values?.length === 3,

            whitelabel_domain: this.company.domain || '',
            stripe_connect_id: this.company.stripeConnectId || '',
            pro_plus_status,
            ...companyPreviousTools,
            ...conditionBasedParentAccProperties,

            // Optional
            // You can add any additional master account level
            // key-values here.
          },
        }
        if (this.company?.data?.hasOwnProperty('has_lc_email')) {
          initObject['parentAccount']['has_lc_email'] = this.company.data.has_lc_email
        }
        if (locationId){
          let locationData = this.$store.getters['locations/getById'](locationId);
          if(!locationData) {
            return;
          }
          // https://support.pendo.io/hc/en-us/articles/360032201831-Managing-multiple-level-accounts
            const yextEnabled = locationData?.reseller?.yext?.location_enabled === false ? false : true
            const wordpressEnabled = locationData?.reseller?.wordpress?.location_enabled === false ? false : true
            initObject['account'] = {
            id: `${this.company.id}::${locationId}`,   // Highly recommended
            name: locationData.name,
            is_saas_enabled: locationData?.settings?.saas_settings?.saas_mode || false,
            company_id: locationData.company_id,
            date_created: moment(locationData.date_added).toISOString(),
            date_updated: moment(locationData.date_updated).toISOString(),
            country: locationData?.country,
            has_yext: locationData?.reseller?.yext?.payment_status === 'COMPLETE',
            has_wordpress: locationData?.reseller?.wordpress?.payment_status === 'COMPLETE',
            has_yext_selling_enabled: yextEnabled,
            has_wordpress_selling_enabled: wordpressEnabled,
            is_fb_page_connected: locationData.facebook_page_id ? true : false,
            // is_loc_twilio_isv_enabled: is_loc_twilio_isv_enabled // Handled seperatelly.
            // Optional
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            // planLevel:    // Optional
            // planPrice:    // Optional
            // creationDate: // Optional

            niche: locationData?.niche_option?.niche,
            phone: locationData?.phone,
            email: locationData?.email || '',
            website: locationData?.website || '',
            platform_language: locationData?.locale_settings?.platform || "en_US",
            outbound_communication_language: locationData?.locale || "",

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
          }

          if(locationData?.google_places_id || locationData?.gmb?.places_id){
            initObject['account']['is_gmb_page_connected'] = true
          }
          if(locationData?.settings?.email_isv_settings?.hasOwnProperty('has_lc_email')){
            initObject['account']['has_lc_email'] = locationData.settings.email_isv_settings.has_lc_email
          }
          let isvLocationsRaw = localStorage.getItem('isv_locations');
          if(isvLocationsRaw) {
            let isvLocations = JSON.parse(isvLocationsRaw);
            if(isvLocations && isvLocations[locationId] !== undefined) {
              initObject['account']['is_loc_twilio_isv_enabled'] = isvLocations[locationId];
            }
          };
          try {
            const twilioAccount = await this.$store.dispatch(
              'twilioAccount/getByLocationId',
              { locationId }
            );
            if (twilioAccount?.underGHLAccount) {
              initObject['account']['has_lc_phone'] = true
            }
            if (Object.keys(twilioAccount?.numberMeta).length) {
              const has_tollfree = Object.values(twilioAccount.numberMeta).some(({ numberType, countryCode }) => (numberType === "tollFree" && countryCode === "US"));
              const has_us_10dlc = !has_tollfree && Object.values(twilioAccount.numberMeta).some(({ numberType }) => (countryCode === "US" && (numberType === "local" || numberType === "mobile")));
              initObject['account']['has_tollfree'] = has_tollfree;
              initObject['account']['has_us_10dlc'] = has_us_10dlc;
            }
          } catch (error) {
          }
        }
        let isInternalUser = window.localStorage.getItem('is_internal_user');
        if (isInternalUser === 'true') {
        } else if (config.mode === 'production' || config.mode === 'staging') {
          if (init) {
            window.pendo && window.pendo.initialize(initObject)
          } else {
            window.pendo && window.pendo.identify(initObject)
          }
        } else {
          console.log('PENDO Object [only in dev mode]', initObject, 'is-init', init)
        }
      } catch (err) {
        console.log('Pendo INIT Failed !!', err)
      }
    },
    identifyCanny() {
      try {
        if (!this.user || !this.company || !window.Canny) {
          return;
        }
        Canny('identify', {
          appID: '612f76b3a11bf815b4eb024b',
          user: {
            companies: [{
              created: moment(this.company.dateAdded).toISOString(),
              id: this.company.id, //agencyid required
              monthlySpend: this.company.stripeActivePlan? parseInt(this.company.stripeActivePlan.split('_')[2]) : 0, // required 97/297/497
              name: this.company.name, // required agency name
              customFields: {
                activePlan: this.company.stripeActivePlan || '',
                status: this.company.status || '',
                country: this.company.country || '',
                relationship_number: this.company.relationshipNumber || '',
                customer_success_rep: this.company.onboardingInfo.meta_data?.customer_success_rep || '',
                // agency_type: 'b2b/ saas/ own customer', // bhaibab
              },
            }],

            created: moment(this.user?._data?.date_added?.seconds * 1000).toISOString(),
            email: this.user?.email || '',
            id: this.user?.id || '',
            name: this.user?.fullName || '',
            customFields: {
              user_role: this.user?.role,
              user_type: this.user?.type,
            },
          },
        });
      } catch (err) {
        console.log('Canny Identify Failed !!', err)
      }
    }
  },
  mounted() {
    if(!String.prototype.replaceAll) {
      window.String.prototype.replaceAll = (str, match, replacement) => {
        return str.replace(new RegExp(match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), ()=>replacement);
      }
    }


    if ( this.$route.name === 'login' && window.pendo) {
      window.pendo.clearSession();
    }
    if( this.$route.name === 'login_page' && window.pendo) {
      window.pendo.clearSession();
      window.localStorage.setItem('is_internal_user', 'true');
    }
    setTimeout( () =>{
      this.initPendo(true)
    }, 3000);
  },
})

Vue.filter('formatNumber', function(value: string | number) {
  if (!value) value = 0
  const locale = getCountryInfo('locale')
  return Number(value).toLocaleString(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })
})

Vue.filter('formatNumberNoDecimal', function(value: string | number) {
  if (!value) value = 0
  const locale = getCountryInfo('locale')
  return Number(value).toLocaleString(locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })
})

Vue.filter('truncate', function(text: string, length?: number, clamp?: string) {
  text = text || ''
  clamp = clamp || '...'
  length = length || 30

  if (text.length <= length) return text

  var tcText = text.slice(0, length - clamp.length)
  var last = tcText.length - 1

  while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0])
    last -= 1

  // Fix for case when text dont have any `space`
  last = last || length - clamp.length

  tcText = tcText.slice(0, last)

  return tcText + clamp
})

Vue.filter('capitalize', function(value: string) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('classify', function(value: string) {
  if (!value) return ''
  return value.toLowerCase().replaceAll(' ', '-')
})

Vue.filter('replaceStorageURL', function(value: string) {
  if (!value) return ''
  return value.indexOf('https://storage.cloud.google.com') === 0
    ? value.replace(
        'https://storage.cloud.google.com',
        'https://storage.googleapis.com'
      )
    : value
})

Vue.filter('toTitleCase', function(str: string) {
  if (str) {
    const words = str.toLowerCase().split(' ')
    for (var i = 0; i < words.length; i++) {
      if (words[i].charAt(0) === '(' && words[i].length > 1) {
        words[i] =
          words[i].charAt(0) +
          words[i].charAt(1).toUpperCase() +
          words[i].slice(2)
      } else {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
      }
    }
    return words.join(' ')
  }
})
Vue.filter('symbole', function(value: string) {
  return currencyList[value] || '$'
})

Vue.filter('str_limit', function (value, size) {
  if (!value) return '';
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + '...';
});

